import type { Machine, MachineDetail } from '@/api/resources/machines'

export interface LocationGroup {
  groupKey: string
  organisationName: string
  locationName: string
  machines: Machine[]
}

export function groupMachinesByLocation(machines: Machine[]): LocationGroup[] {
  const groups = new Map<string, LocationGroup>()

  for (const machine of machines) {
    const organisationId = machine.organisation?.id ?? 0
    const locationId = machine.location?.id ?? 0
    const groupKey = `${organisationId}:${locationId}`
    const existing = groups.get(groupKey)
    if (existing !== undefined) {
      existing.machines.push(machine)
    } else {
      groups.set(groupKey, {
        groupKey,
        organisationName: machine.organisation?.name ?? 'Unassigned',
        locationName: machine.location?.name ?? 'Unassigned',
        machines: [machine],
      })
    }
  }

  return Array.from(groups.values()).sort((a, b) => {
    const nameA = `${a.organisationName} ${a.locationName}`.toLowerCase()
    const nameB = `${b.organisationName} ${b.locationName}`.toLowerCase()
    return nameA.localeCompare(nameB)
  })
}

export function hasMachineWarning(machine: Machine): boolean {
  return machine.status_category === 'offline' || machine.status_category === 'needs-attention'
}

export const MACHINE_TYPE_IMAGES: Record<string, string> = {
  drinks: '/images/machines/drinks.png',
  snacks: '/images/machines/snacks.png',
  fridge: '/images/machines/fridge.png',
}

export function getMachineImage(type: string): string {
  return MACHINE_TYPE_IMAGES[type.toLowerCase()] ?? '/images/machines/snacks.png'
}

export function isCustomizeMachine(
  machine: Pick<MachineDetail, 'subscription_type' | 'auto_refill'>,
): boolean {
  return machine.subscription_type === 'revenue' && !machine.auto_refill
}

export function isProfessionalMachine(
  machine: Pick<MachineDetail, 'subscription_type' | 'auto_refill'>,
): boolean {
  return machine.subscription_type === 'revenue' && machine.auto_refill === true
}
